import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Department } from '@signal/asp-data-commons';
import { Observable } from 'rxjs';
import { DateTime } from 'luxon';
import { AspSalesAdminRoles, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { IDashboardDetails, ScheduleDashboardState } from '../../store/schedule-dashboard/schedule-dashboard.reducer';
import { DashboardOverlayService } from '../../shared/services/dashboardoverlay.service';
import { Store } from '@ngrx/store';
import { DashboardOverlay } from '../../shared/components/dashboard-overlay/dashboard-overlay.component';
import { MatDialog } from '@angular/material/dialog';
import * as fromScheduleDashboardActions from '../../store/schedule-dashboard/schedule-dashboard.action';
import * as fromScheduleDashboardSelector from '../../store/schedule-dashboard/schedule-dashboard.selectors';
import { DashboardPrintOverlay } from '../../shared/components/dashboard-print-overlay/dashboard-print-overlay.component';
import { SubscriptionList } from '../../shared/models/asp.types';

@Component({
  selector: 'app-sales-schedule-dashboard',
  templateUrl: './sales-schedule-dashboard.component.html',
  styleUrls: ['./sales-schedule-dashboard.component.scss']
})
export class SalesScheduleDashboardComponent implements OnInit, OnDestroy {

  hoursOfOperation: string = '';
  department: Department = Department.SALES;
  dashboardDetails$ : Observable<IDashboardDetails>;
  dashboardDetails: IDashboardDetails;
  refreshTime: string = DateTime.now().toFormat('t');
  private userRoles: string[] = [];
  requiredRoles = [...AspSalesAdminRoles];
  isOverrideAllowed: boolean = true;
  isServiceRole: boolean = false;
  refreshInterval;
  appointmentDetails:any[];
  dateFormat : string = 'yyyy-MM-dd';
  private subs: SubscriptionList = {};
  
  constructor(private cdref: ChangeDetectorRef,public dashboardOverlayService:DashboardOverlayService,
    private scheduleDashboardState: Store<ScheduleDashboardState>,public dialog: MatDialog) { 
    this.dashboardOverlayService.dispatchActions(this.department);
    this.dashboardOverlayService.getdatavalue(this.department);
  }

  ngOnInit(): void {
    this.setUpStore();
    this.refreshInterval = setInterval(()=>{
     this.autoRefresh();
    },300000)
  }
  setUpStore(){
    this.dashboardDetails$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardDetails);
    this.subs.dashboardDetails = this.dashboardDetails$.subscribe(details => {
      this.dashboardDetails = details;
    });
  }
  onHoursOfOperationChange(event: string){
    this.hoursOfOperation = event;
  }

  ngAfterContentChecked() {

    if (!this.cdref['destroyed']) {
      this.cdref.detectChanges();    
    }

  }

  refresh(){
    const startDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).startOf('month').toFormat(this.dateFormat);
    const endDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).endOf('month').toFormat(this.dateFormat);
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardSlot({department: this.department, endDate: endDateForSlot, startDate: startDateForSlot}));
    if(this.dashboardDetails.viewMode !== 'Month'){
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointments({department: this.department, endDate: this.dashboardDetails.endDate, 
      startDate: this.dashboardDetails.startDate, filters: this.dashboardDetails.filterValue, viewMode: this.dashboardDetails.viewMode}));
    }
    
  }
  launchdashboardoverlay(){
    const dialogRef = this.dialog.open(DashboardOverlay ,{
        height:'560px',
        width: '40%',
        panelClass:'dashboard-overlay-cdk'
    });

    this.subs.dialogRef = dialogRef.afterClosed().subscribe(result => {
      
    });
  }

autoRefresh(){
  this.refreshTime = DateTime.now().toFormat('t');
  // const startDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).startOf('month').toFormat(this.dateFormat);
  // const endDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).endOf('month').toFormat(this.dateFormat);
  // this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardSlot({department: this.department, endDate: endDateForSlot, startDate: startDateForSlot}));
  if(this.dashboardDetails.viewMode === 'Day'){
  this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointmentsRefresh({department: this.department, endDate: this.dashboardDetails.endDate, 
    startDate: this.dashboardDetails.startDate, filters: this.dashboardDetails.filterValue, viewMode: this.dashboardDetails.viewMode}));
  }
}

  openPrintOverlay(){
    const dialogRef = this.dialog.open(DashboardPrintOverlay ,{
        height:'560px',
        panelClass:'dashboard-overlay-cdk',
        data: {department:this.department,appointmentDetails:this.appointmentDetails, clicked: true}
    });

    this.subs.dialogRef = dialogRef.afterClosed().subscribe(result => {
    });
  
}
emitAppointmentDetails(event){
  this.appointmentDetails = event;
}
ngOnDestroy(){
  this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.ClearScheduleDashboardSlot({department: this.department}));
  unsubscribeSubscriptions(this.subs);
  this.cdref.detach();
}
}
